import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["aria-label", "aria-labelledby", "children", "className", "component", "href", "primary", "prompt", "dangerouslyForceActiveStyling", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling"];
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { useId } from '@nerdwallet/react-accessibility';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { Type } from '../Type/Type';
import style from './Card.module.less';

/**
 * Cards indicate to a user that a group of content is actionable and accessible.
 *
 * `Card` mounts an `<a>` by default.
 */
export var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      children = props.children,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'a' : _props$component,
      href = props.href,
      primary = props.primary,
      prompt = props.prompt,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      otherProps = _objectWithoutProperties(props, _excluded);

  useDeprecatedClassNameStylePropsWarning('Card', {
    className: className
  });
  var promptId = useId();
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": promptId,
    "data-currency": "Card",
    className: classNames(style.card, (_classNames = {}, _defineProperty(_classNames, classes('shadow-1'), primary), _defineProperty(_classNames, style['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classNames, style['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classNames, style['force-hover'], dangerouslyForceHoverStyling), _classNames), className),
    href: href,
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(Box, {
    className: style.cardChildren
  }, children), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Type, {
    color: "blue",
    component: "p",
    fontFamily: "gotham",
    size: 2,
    "aria-hidden": "true",
    id: promptId
  }, prompt)));
});
Card.displayName = 'Card';